/*
  Copyright 2018-2020 National Geographic Society
  Copyright 2021-2022 Impact Observatory

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

export interface IAnalysis {
  id?: any;
  slug: string;
  name: string;
  description: string;
  type: IAnalysisType;
  config: IAnalysisConfig;
  published: boolean;
  // auto-generated;
  createdAt?: Date;
  updatedAt?: Date;
  version?: number;
  // relationships;
  organization?: string;
}

export interface IAnalysisConfig {
  HANDLER_URL: string;
  location: string[];
}

export enum IAnalysisType {
  ELSA = 'ELSA',
  // MOD = 'MOD',
}

export enum AnalysisTypeEnum {
  ELSA = 'ELSA',
}

export enum AnalysisResultStatusEnum {
  READY = 'READY',
  STARTED = 'STARTED',
  ERROR = 'ERROR',
  COMPLETE = 'COMPLETE',
}

export interface IAnalysisResult {
  id?: any;
  name: string;
  slug: string;
  type: AnalysisTypeEnum;
  status: AnalysisResultStatusEnum;
  result: object;
  createdAt?: Date;
  updatedAt?: Date;
  // relationships;
  analysis: string;
  location: string;
  organization?: string;
  task?: string;
}

export interface ELSAOutput {
  name: string;
  file_path: string;
}
